import script from "./DemoLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoLayout.vue?vue&type=script&setup=true&lang=js"

import "@/styles/console.css?vue&type=style&index=0&lang=css&external"
import "./DemoLayout.vue?vue&type=style&index=1&id=6bd306fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd306fc"]])

export default __exports__